import React, { useState } from "react";
import toast from "react-hot-toast";
import {
    ADD_ZONE_COUVERTURE,
    RECUPERER_ZONE_COVERTURE_FICHIER,
} from "../../Utils/constant";
import { ArrowRight } from "../../components/Icons/ArrowRight";
import { File } from "../../components/Icons/File";
import { store, find } from "../../services/service";
import Kml from "../../components/Widget/Kml";

export const ZoneCouverture = () => {
    const [fichierCreation, setFichierCreation] = useState("");
    const [fileZoneCouverte, setFileZoneCouverte] = useState(null);
    const [gettingFile, setGettingFile] = useState(false);
    const [loadingUpload, setLoadingUpload] = useState(false);
    const [voirZone, setVoirZone] = useState(false);

    const handleFileInputCreationTicket = (e) => {
        const fileUploaded = e.target.files[0];

        if (fileUploaded || fileUploaded !== undefined) {
            setFichierCreation(fileUploaded);
        }
    };

    const recupereNouveauFichier = () => {
        setGettingFile(true);
        find(RECUPERER_ZONE_COVERTURE_FICHIER)
            .then((res) => {
                setGettingFile(false);
                setFileZoneCouverte(res.data);
            })
            .catch((err) => {
                setGettingFile(false);
                toast.error(err?.response?.data?.donnee);
            });
    };

    const sendFileToserver = () => {
        setLoadingUpload(true);
        const formData = new FormData();
        formData.append("fichier", fichierCreation);

        store(ADD_ZONE_COUVERTURE, "multipart/form-data", formData)
            .then((res) => {
                setLoadingUpload(false);
                if (res.status === 200) {
                    recupereNouveauFichier();
                    toast.success("Fichier chargé avec succès");
                    setFichierCreation("");
                }
            })
            .catch((err) => {
                setLoadingUpload(false);
                console.log("ppp", err);
                if (err && err.response && err.response.data) {
                    toast.error(err.response.data.donnee);
                } else {
                    toast.error("Une erreur s'est produite");
                }
            });
    };

    React.useEffect(() => {
        setGettingFile(true);
        find(RECUPERER_ZONE_COVERTURE_FICHIER)
            .then((res) => {
                setGettingFile(false);
                setFileZoneCouverte(res.data);
            })
            .catch((err) => {
                setGettingFile(false);
                toast.error(err?.response?.data?.donnee);
            });
    }, []);

    return (
        <div className="">
            <h3 class="text-3xl font-bold font-mtn">Zone de couverture</h3>
            {!voirZone ? (
                <div>
                    <div className="mt-12">
                        <p className="text-sm text-gray-500 font-medium">Dernier fichier</p>
                    </div>
                    <div className="mt-1 w-full lg:w-10/12 bg-white rounded-lg p-3 border border-[#f2f5fa] flex items-center justify-between gap-x-5 shadow-sm">
                        <div>
                            <p className="text-lg text-black font-bold">
                                {fileZoneCouverte && fileZoneCouverte.fichier
                                    ? fileZoneCouverte.fichier.nom
                                    : "-"}
                            </p>
                            <p className="text-sm text-gray-500 font-medium">
                                Chargé le:{" "}
                                {fileZoneCouverte
                                    ? new Date(fileZoneCouverte.dateCreation).toLocaleDateString()
                                    : "-"}
                            </p>
                        </div>
                        <div>
                            <button
                                className="w-24 h-10 pl-2 rounded-full bg-main text-black font-semibold flex items-center justify-center text-base font-semibold"
                                onClick={() => setVoirZone(true)}
                            >
                                Ouvrir
                                <ArrowRight />
                            </button>
                        </div>
                    </div>
                    <div className="mt-3 relative w-full lg:w-10/12 bg-white rounded-lg p-3 border border-[#f2f5fa] shadow-sm">
                        <button
                            disabled={loadingUpload}
                            className="w-full mx-auto h-36 bg-stone-50 border border-dashed rounded-lg flex items-center justify-center cursor-pointer"
                            onClick={() => document.getElementById("file-zone").click()}
                        >
                            <div className="flex flex-col items-center text-gray-400">
                                <File />
                                {fichierCreation ? (
                                    <div className="mt-2 w-full flex flex-col items-center justify-center">
                                        <div className="text-black font-semibold flex items-center justify-center font-medium">
                                            {fichierCreation.name}
                                        </div>
                                    </div>
                                ) : (
                                    <p className="text-base text-center font-semibold">
                                        Cliquer pour sélectionner le fichier à charger
                                    </p>
                                )}
                            </div>
                        </button>
                        {fichierCreation ? (
                            <button
                                disabled={loadingUpload}
                                className="mt-4 bg-main text-black text-sm font-semibold w-40 mx-auto h-8 rounded-lg flex items-center justify-center gap-x-1"
                                onClick={sendFileToserver}
                            >
                                {loadingUpload ? (
                                    <span className="flex items-end justify-center gap-x-1">
                                        Chargement{" "}
                                        <span className="loading loading-dots loading-xs"></span>
                                    </span>
                                ) : (
                                    "Charger le fichier"
                                )}
                            </button>
                        ) : null}

                        <input
                            id="file-zone"
                            type="file"
                            // accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            onChange={handleFileInputCreationTicket}
                            style={{ display: "none" }}
                        />
                    </div>
                </div>
            ) : null}

            {voirZone ? (
                <div className="mt-8">
                    <button
                        className="bg-black text-white text-sm font-semibold w-fit px-4 h-8 rounded-lg mb-4"
                        onClick={() => setVoirZone(false)}
                    >
                        Retour
                    </button>
                    <Kml
                        zoneCouverte={fileZoneCouverte ? fileZoneCouverte.fichier : null}
                    />
                </div>
            ) : null}
        </div>
    );
};
